var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimezIcn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 196 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 196,
    fill: "#333444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9482 177.004V196H14.7607L14.7607 177.004H23.9482ZM63.2822 160.398V196H54.0947V160.398H63.2822ZM102.616 177.004V196H93.4287V177.004H102.616ZM141.95 160.398V196H132.763V160.398H141.95ZM181.284 177.004V196H172.097V177.004H181.284Z",
    fill: "#FF6347"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.96 75.9698H114.221V149.68H81.8242V75.9698H52.085V46.3203H143.96V75.9698Z",
    fill: "#FF6347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimezIcn);
export default __webpack_public_path__ + "static/media/timez_icn.492b184d6a4ca2d48f8295e396e188ed.svg";
export { ForwardRef as ReactComponent };